import qs from "qs";
import get from "lodash/get";
import { api } from "../config";

const getSlug = async (slug, locale?: string) => {
  const queryObj = {
    filters: {
      Slug: {
        $eq: slug,
      },
    },
    populate: {
      SEO: "*",
      OwnerProduct: {
        populate: {
          Hero: {
            populate: "*",
          },
          Image: "*",
          Media: "*",
        },
      },
      Product: {
        populate: {
          Hero: {
            populate: {
              Media: "*",
              CTA: {
                populate: {
                  page: {
                    fields: ["Slug"],
                  },
                },
              },
            },
          },
          Image: "*",
          Media: "*",
          Overview: {
            populate: "*",
          },
          Specification: {
            populate: [
              "OptionalItems",
              "OptionalItems.Media",
              "Specifications",
            ],
          },
        },
      },
      Content: {
        populate: {
          Downloads: "*",
          page: "*",
          Media: "*",
          Gallery: "*",
          CTA1: {
            populate: "*",
          },
          CTA2: {
            populate: "*",
          },
          Link: {
            populate: "*",
          },
          Events: {
            populate: "*",
          },
          Cards: {
            populate: "*",
          },
          Items: {
            populate: "*",
          },
          TestimonialCards: {
            populate: "*",
          },
          associations: {
            populate: "*",
          },
          brands: {
            populate: "*",
          },
          Map: {
            populate: "*",
          },
          Social: {
            populate: "*",
          },
          Phone: {
            populate: "*",
          },
          Email: {
            populate: "*",
          },
          Directions: {
            populate: "*",
          },
          contacts: {
            populate: "*",
          },
          ApplyFilters: {
            fields: ["id"],
          },
          Product: {
            fields: ["id"],
          },
          Filters: "*",
          products: {
            populate: {
              Image: "*",
              Tags: "*",
              Page: "*",
              OwnerPage: "*",
            },
          },
        },
      },
    },
  };
  if (locale) queryObj["locale"] = locale;

  const query = qs.stringify(queryObj, {
    encodeValuesOnly: true,
  });

  try {
    const res: any = await fetch(`${api}/pages?${query}`);
    res.data = await res.json();
    if (get(res.data, "data[0]")) res.data.data = res.data.data[0];
    return res;
  } catch (err) {
    if (!locale) return;
    if (locale.split("-").length > 1) {
      return await getSlug(slug, locale.split("-")[0]);
    } else {
      return await getSlug(slug);
    }
  }
};

export { getSlug };